export default __webpack_public_path__ + "static/magdak-901994f9b8ed0d884a0318ff35f00e83.jpg";